/** @format */

const template = `
<div class="course-unit-inline-block">
  <common-course-unit
    ng-if="!$ctrl.hasSubstitutions()"
    course-unit-id="$ctrl.courseUnitId"
    parent-module-id="$ctrl.parentModuleId"
    parent-module-group-id="$ctrl.parentModuleGroupId"
    validatable-plan="$ctrl.validatablePlan"
    show-expiry-warning="$ctrl.showExpiryWarnings"
    show-selected-parent="$ctrl.showSelectedParent">
  </common-course-unit
  ><div
    ng-if="$ctrl.substitutions.length > 0"
    ng-class="{'substituted-course-unit':$ctrl.substitutions.length === 1, 'courseunit-substitution-group': $ctrl.substitutions.length > 1}"
    ><common-course-unit
      ng-repeat="substitution in $ctrl.substitutions"
      course-unit-id="substitution"
      parent-module-id="$ctrl.parentModuleId"
      parent-module-group-id="$ctrl.parentModuleGroupId"
      validatable-plan="$ctrl.validatablePlan"
      is-substitution="true"
      substitute-for="$ctrl.courseUnitId"
      show-expiry-warning="$ctrl.showExpiryWarnings"
      show-selected-parent="$ctrl.showSelectedParent"></common-course-unit
  ></div>
</div>
`;
export default template;
